'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lang = require('lodash/lang');

var _footerPage = require('./footerPage.js');

var _footerPage2 = _interopRequireDefault(_footerPage);

var _footerIconList = require('./footerIconList');

var _footerIconList2 = _interopRequireDefault(_footerIconList);

var _footerOtherLink = require('./footerOtherLink');

var _footerOtherLink2 = _interopRequireDefault(_footerOtherLink);

var _footerSubpage = require('./footerSubpage');

var _footerSubpage2 = _interopRequireDefault(_footerSubpage);

var _reactI18next = require('react-i18next');

var _i18n = require('../utils/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

require('./footer.css');

require('../icon.css');

require('../fa.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Footer(props) {
    var FooterColStyle = {
        minWidth: 140,
        maxWidth: 180
    };
    var loadingComplete = props.loadingComplete,
        currentLang = props.currentLang;

    var _useState = (0, _react.useState)(null),
        _useState2 = _slicedToArray(_useState, 2),
        selectedKey = _useState2[0],
        setSelectedKey = _useState2[1];

    var _useState3 = (0, _react.useState)(!(0, _lang.isEmpty)(props.aioURL) ? props.aioURL : 'http://www.hkbn.net/personal/'),
        _useState4 = _slicedToArray(_useState3, 2),
        aioURL = _useState4[0],
        setAIOURL = _useState4[1];

    var _useState5 = (0, _react.useState)(!(0, _lang.isEmpty)(props.myAccountURL) ? props.myAccountURL : 'http://www.hkbn.net/'),
        _useState6 = _slicedToArray(_useState5, 2),
        myAccountURL = _useState6[0],
        setMyAccountURL = _useState6[1];

    (0, _react.useEffect)(function () {
        _i18n2.default.changeLanguage(currentLang === 'eng' ? 'en-US' : 'zh-HK');
    }, [currentLang]);

    var toggleFooter = function toggleFooter(idx) {
        setSelectedKey(selectedKey === idx ? null : idx);
    };

    var handleItemClick = function handleItemClick(fullURL, caller) {
        var hasReplaceableSiteOrigin = fullURL.match(/\[\[.*?\]\]/);
        var url = void 0;
        var path = void 0;
        var urlOrigin = void 0;

        if (!(0, _lang.isEmpty)(hasReplaceableSiteOrigin)) {
            urlOrigin = hasReplaceableSiteOrigin[0].slice(0, -2).substring(2);
            switch (urlOrigin) {
                case 'aio':
                    url = fullURL.replace('[[aio]]', aioURL);
                    path = fullURL.replace('[[aio]]', '');
                    break;
                case 'myaccount':
                    url = fullURL.replace('[[myaccount]]', myAccountURL);
                    path = fullURL.replace('[[myaccount]]', '');
                    break;
                default:
                    url = fullURL;
                    break;
            }
        } else {
            urlOrigin = 'default';
            url = fullURL;
        }

        props.onURLClick(url, path, caller, urlOrigin);
    };

    var returnFullURL = function returnFullURL(fullURL) {
        if ((0, _lang.isEmpty)(fullURL)) {
            return;
        }
        var hasReplaceableSiteOrigin = fullURL.match(/\[\[.*?\]\]/);
        var urlOrigin = void 0;
        var url = fullURL;
        if (!(0, _lang.isEmpty)(hasReplaceableSiteOrigin)) {
            urlOrigin = hasReplaceableSiteOrigin[0].slice(0, -2).substring(2);
            switch (urlOrigin) {
                case 'aio':
                    url = fullURL.replace('[[aio]]', aioURL);
                    break;
                default:
                    url = fullURL;
                    break;
            }
        }

        return url;
    };

    if (!loadingComplete) {
        return false;
    }

    return _react2.default.createElement(
        _reactI18next.I18nextProvider,
        { i18n: props.i18n },
        _react2.default.createElement(
            'div',
            { className: 'page-footer footer-background container-fluid' },
            _react2.default.createElement(
                'div',
                { className: 'footer-container' },
                _react2.default.createElement(
                    'div',
                    { className: 'row footer px-4 px-lg-5' },
                    _react2.default.createElement(_footerPage2.default, {
                        FooterColStyle: FooterColStyle,
                        selectedKey: selectedKey,
                        toggleFooter: toggleFooter,
                        onURLClick: function onURLClick(fullURL, caller) {
                            handleItemClick(fullURL, caller);
                        },
                        returnFullURL: returnFullURL
                    }),
                    _react2.default.createElement(_footerOtherLink2.default, {
                        onURLClick: function onURLClick(fullURL, caller) {
                            handleItemClick(fullURL, caller);
                        },
                        returnFullURL: returnFullURL
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row footer additional px-4 px-lg-5' },
                    _react2.default.createElement(_footerSubpage2.default, {
                        onURLClick: function onURLClick(fullURL, caller) {
                            handleItemClick(fullURL, caller);
                        },
                        returnFullURL: returnFullURL
                    }),
                    _react2.default.createElement(_footerIconList2.default, {
                        onURLClick: function onURLClick(fullURL, caller) {
                            handleItemClick(fullURL, caller);
                        },
                        returnFullURL: returnFullURL
                    })
                )
            )
        )
    );
}

exports.default = Footer;